import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { useState } from "react";
import type { ProblemListItem } from "shared";
import { api } from "../api";
import { useCallerState } from "../callerState";

export function Problems() {
  const { state } = useCallerState();
  const [filter, setFilter] = useState("");
  const q = useQuery({ queryKey: ["problems"], queryFn: () => api<{ problems: ProblemListItem[] }>("/api/kb/problems") });
  const shown = (q.data?.problems ?? []).filter((p) =>
    `${p.title} ${p.summary ?? ""} ${p.category?.name ?? ""}`.toLowerCase().includes(filter.toLowerCase()));
  const groups = new Map<string, ProblemListItem[]>();
  for (const p of shown) {
    const k = p.category?.name ?? "Other";
    groups.set(k, [...(groups.get(k) ?? []), p]);
  }
  return (
    <div className="mx-auto max-w-5xl">
      <h1 className="mb-1 text-xl font-semibold">Customer problems</h1>
      <p className="mb-4 text-sm text-slate-500">What to ask, what to collect, and which programs to check for common situations.</p>
      <input className="input mb-4" aria-label="Filter problems" placeholder="Filter, e.g. rent" value={filter} onChange={(e) => setFilter(e.target.value)} />
      {q.isLoading && <p className="text-sm text-slate-500">Loading…</p>}
      {q.error && <p role="alert" className="text-sm text-red-600">Could not load problems.</p>}
      {q.data && shown.length === 0 && <p className="text-sm text-slate-500">No problems match.</p>}
      {[...groups.entries()].sort(([a], [b]) => a.localeCompare(b)).map(([cat, items]) => (
        <section key={cat} className="mb-4">
          <h2 className="label">{cat}</h2>
          <ul className="grid gap-2 sm:grid-cols-2">{items.map((p) => (
            <li key={p.id}>
              <Link to="/problems/$slug" params={{ slug: p.slug }} search={{ state }} className="card block hover:border-brand-500">
                <div className="font-medium">{p.title}</div>
                {p.summary && <div className="text-sm text-slate-500">{p.summary}</div>}
                <div className="mt-1 text-xs text-slate-500">{p.programCount} linked programs</div>
              </Link>
            </li>
          ))}</ul>
        </section>
      ))}
    </div>
  );
}
